<template>
  <SmartLinkItemComponent :id="model.system.id" :component="!model.system.workflow" :custom-tag="fromFooter ? 'li' : 'span'">
    <SmartLinkStandaloneElement
      :codename="typ.elements.label.codename"
      class="contact-item open-text"
    >
      <span>
        <font-awesome class="contact-icon fa-fw" :icon="data.icon" v-if="data.icon" />
      </span>
      <span v-if="data.label" class="contact-label">{{ data.label }}</span>
      <span>
        <div class="contact-text">
          <RichText :value="data.text" />
        </div>
      </span>
    </SmartLinkStandaloneElement>
  </SmartLinkItemComponent>
</template>
<script lang="ts" setup>
import type { ContactItemOpenTextModel } from '~/models'
import { contentTypes } from '~/models'
const typ = contentTypes._contact_item___open_text

const props = defineProps<{ model: ContactItemOpenTextModel, fromFooter: boolean }>()

const model = props.model as ContactItemOpenTextModel
const data = {
  label: model.elements.label.value,
  text: model.elements.text.value,
  icon: firstOrDefault(model.elements.icon.value)
}
</script>
